import { ICardContract } from './types'
import { Flex, Loader, Drawer, Divider, Button, Tab, ToolTip } from '@ui/index'
import { IconClearClose, IconFiles, IconLogs, IconMainGrid } from '@img/icons'
import { OpenAIOutlined } from '@ant-design/icons'

import logoYaSkill from '@img/logo_yaskill.svg'
import logoModSkill from '@img/logo_modskill.svg'

import css from './ui.module.scss'


/** Анкета по договору */
export const CardContract = ({ loadingTitle,
    isOpen, cardMode,
    isLoading, isDisableBtnSave, tabActive, contractID, contractsDateCreate, dataBaseName, createdAI, txtOutsideMoodle,
    filesList, txtApplicationID,

    getCardPage,
    handlerOpenModalConfirm, handlerOpenModalContractUpload, handlerOpenModalContractSended,
    handlerGenerateDocuments, handlerDeleteFiles, handlerDownloadFiles, handleBtnClose, handleBtnSave,
}: ICardContract) => {    
    const siteLogo = dataBaseName.value === 'yaskill'
        ? {src: logoYaSkill, name: 'YaSkill'}
        : dataBaseName.value === 'modern_academy'
            ? {src: logoModSkill, name: 'ModSkill'}
            : null

    /** Получение сообщения при нажатии на кнопку - Допуск к обучению */
    const getMessageToCreateLogin = () => {
        if (txtOutsideMoodle.value === 1) { // Если обучение вне moodle
            return 'Внимание! Все слушатели по данному договору будут обучаться самостоятельно, вне учебной платформы MOODLE.<br /><br />Вы подтверждаете это?'
        }

        return 'Вы действительно хотите предоставить доступ в личный кабинет, нашей учебной платформы?'
    }
    
    /** Функция по получению кнопочной панели в низу анкеты, в зависимости от выбранной вкладки */
    const getCardPageBtnPanel = (tabActive: string) => {
        switch (tabActive) {
            case 'primary': {
                return <Flex gap='4px'>
                    <Divider />
                    <Flex flexDirection='row' gap='4px' justifyContent='flex-end'>
                        <Flex flexDirection='row' gap='4px' isRendered={cardMode === 'edit'}>
                            <Button variant='primaryDark' padding='0 10px' onClick={() => handlerOpenModalConfirm(true, 'Допуск к обучению', getMessageToCreateLogin(), 'createLogin')}>
                                Допуск к обучению
                            </Button>

                            <Divider type='vertical' margin='8px' />
                        </Flex>

                        <Button padding='0 10px' isDisabled={isDisableBtnSave.value || isLoading} onClick={() => handleBtnSave(true)}>Сохранить и закрыть</Button>
                        <Button padding='0 10px' isDisabled={isDisableBtnSave.value || isLoading} onClick={() => handleBtnSave(false)}>Сохранить</Button>
                    </Flex>
                </Flex>
            }

            case 'files': {
                return <Flex gap='4px'>
                    <Divider />
                    <Flex flexDirection='row' gap='4px' justifyContent='flex-end' flexWrap='wrap'>
                        <Flex flexDirection='row' gap='4px' isRendered={filesList.value.filter((item) => item.isSelected).length > 0}>
                            <Button variant='icon' padding='0 10px' onClick={() => handlerDeleteFiles()}>Удалить</Button>
                            <Button variant='icon' padding='0 10px' onClick={() => handlerDownloadFiles()}>Скачать</Button>
                            <Divider type='vertical' margin='8px' />
                        </Flex>

                        <Flex flexDirection='row' gap='4px'>
                            <Button variant='primaryDark' padding='0 10px' onClick={() => handlerOpenModalContractSended(true)}>Отправить</Button>
                            <Button variant='primaryDark' padding='0 10px' onClick={handlerGenerateDocuments}>Сформировать</Button>
                        </Flex>

                        <Divider type='vertical' margin='8px' />
                        <Button padding='0 10px' onClick={() => handlerOpenModalContractUpload(true)}>Загрузка</Button>
                    </Flex>
                </Flex>
            }

            case 'detailing': {
                return ''
            }

            case 'logs': return ''
        }
    }

    return <>
        <Drawer isOpen={isOpen} placement='bottom' size='99.4%'>
            <Flex className='drawer_container'>
                <Flex flexDirection='row' alignItems='center' justifyContent='space-between' className='drawer_container-header'>
                    <header>
                        <Flex gap='4px' flexDirection='row' alignItems='center'>
                            {siteLogo && <img className={css['header_logo']} src={siteLogo.src} alt={`Логотип ${siteLogo.name}`} />}
                            <h4>{cardMode === 'edit' ? 'Анкета договора' : 'Создание договора'}</h4>
                            {cardMode === 'edit' && createdAI.value === 1 &&
                                <ToolTip title='Договор создан с помощью ИИ' placement='bottom'>
                                    <span className={css['ai_indicator']} role='img' aria-label='Договор создан с помощью ИИ'>
                                        <OpenAIOutlined aria-hidden />
                                    </span>
                                </ToolTip>
                            }
                        </Flex>

                        {cardMode === 'edit' && <h5>№ {contractID} от {contractsDateCreate.value} (👉 {txtApplicationID.value})</h5>}
                    </header>

                    <Button id='tooltipBtnClose' variant='icon' size='md' isDisabled={isLoading} onClick={handleBtnClose}>
                        <IconClearClose />
                    </Button>
                </Flex>

                <Flex gap='4px' className='drawer_container-body_bottom_panel'>
                    <Flex gap='6px' className='drawer_container-content' overflowY={['files', 'listeners'].includes(tabActive.value) ? 'hidden' : 'scroll'} padding={['files', 'listeners'].includes(tabActive.value) ? '2px 0px 0px 0px' : '4px 8px 4px 4px'}>
                        {getCardPage(tabActive.value)}
                    </Flex>

                    {getCardPageBtnPanel(tabActive.value)}
                </Flex>

                <Tab.Container isVisible={cardMode === 'edit'}>
                    <Tab.Item tabName='primary' tabNameActive={tabActive.value} tabToolTipPlace='topLeft' tabToolTipTitle='Основные данные' onClick={tabActive.setValue}><IconMainGrid /></Tab.Item>
                    <Tab.Item tabName='files' tabNameActive={tabActive.value} tabToolTipPlace='topLeft' tabToolTipTitle='Файлы' onClick={tabActive.setValue}><IconFiles /></Tab.Item>
                    <Tab.Item tabName='logs' tabNameActive={tabActive.value} tabToolTipPlace='topLeft' tabToolTipTitle='Журнал изменений' onClick={tabActive.setValue}><IconLogs /></Tab.Item>
                </Tab.Container>

                <Loader isOpen={isLoading} title={loadingTitle.value} backdrop />
            </Flex>
        </Drawer>
    </>
}